import { HttpCodeProps } from "../types";

export const HttpCodes = {
  Success: 200 as HttpCodeProps,
  Created: 201 as HttpCodeProps,
  Accepted: 202 as HttpCodeProps,
  NoContent: 204 as HttpCodeProps,
  BadRequest: 400 as HttpCodeProps,
  Unauthorized: 401 as HttpCodeProps,
  Forbidden: 403 as HttpCodeProps,
  NotFound: 404 as HttpCodeProps,
  MethodNotAllowed: 405 as HttpCodeProps,
  Conflict: 409 as HttpCodeProps,
  InternalServerError: 500 as HttpCodeProps,
};

export const AppName = "Virel";
export const AppFullName = "Virel - Reward Your Lifestyle";

export const AdminPermissions = {
  MANAGE_ADMINS: "admin.manage",
  MANAGE_USERS: "user.manage",
  MANAGE_MISSIONS: "mission.manage",
  MANAGE_PROOFS: "proof.manage",
  MANAGE_WITHDRAWALS: "withdrawal.manage",
  VIEW_AUDIT_LOGS: "audit.view",
  MANAGE_CONFIG: "config.manage",
  MANAGE_INVITES: "invite.manage",
  MANAGE_LEVELS: "level.manage",
  MANAGE_VERIFICATION: "verification.manage",
} as const;

export const AdminPermissionList = Object.values(AdminPermissions);

export const PermissionLabels: Record<string, string> = {
  [AdminPermissions.MANAGE_ADMINS]: "Manage Admins (Team)",
  [AdminPermissions.MANAGE_USERS]: "Manage Users",
  [AdminPermissions.MANAGE_MISSIONS]: "Manage Activities",
  [AdminPermissions.MANAGE_PROOFS]: "Manage Proofs",
  [AdminPermissions.MANAGE_WITHDRAWALS]: "Manage Withdrawals",
  [AdminPermissions.VIEW_AUDIT_LOGS]: "View Audit Logs",
  [AdminPermissions.MANAGE_CONFIG]: "Manage System Config",
  [AdminPermissions.MANAGE_INVITES]: "Manage Invites",
  [AdminPermissions.MANAGE_LEVELS]: "Manage Levels",
  [AdminPermissions.MANAGE_VERIFICATION]: "Manage Verification & Access",
};

export const virelCore: string[] = [
  "bidemi.ajiboye@gmail.com",
  "bigbrotherrecords01@gmail.com",
  "me@theajstars.co",
  "atajiboyeo@gmail.com",
  "theajstars@gmail.com",
];
